import React, { useState } from 'react';

/**
 * WatermarkOverlay - Rooam logo watermark for video player
 * Semi-transparent overlay in configurable corner
 */
export function WatermarkOverlay({ 
  enabled = true,
  logoUrl = '/rooam-logo.png',
  position = 'top-right', // top-left, top-right, bottom-left, bottom-right
  opacity = 0.6,
  scale = 1.0
}) {
  const [imageError, setImageError] = useState(false);

  if (!enabled) return null;

  const positionClasses = {
    'top-left': 'top-4 left-4',
    'top-right': 'top-4 right-4',
    'bottom-left': 'bottom-4 left-4',
    'bottom-right': 'bottom-4 right-4'
  };

  // Default size: 80px width, scaled
  const baseSize = 80 * scale;

  // Fallback text component (XSS-safe)
  const FallbackText = () => (
    <div 
      style={{
        background: 'rgba(0,0,0,0.6)',
        padding: '4px 12px',
        borderRadius: '4px',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px',
        letterSpacing: '1px'
      }}
    >
      ROOAM
    </div>
  );

  return (
    <div 
      className={`absolute ${positionClasses[position]} z-10 pointer-events-none`}
      data-testid="watermark-overlay"
      style={{ opacity }}
    >
      {imageError ? (
        <FallbackText />
      ) : (
        <img 
          src={logoUrl}
          alt="Rooam Sports"
          className="drop-shadow-lg"
          style={{ 
            width: `${baseSize}px`,
            height: 'auto',
            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))'
          }}
          onError={() => setImageError(true)}
        />
      )}
    </div>
  );
}

export default WatermarkOverlay;
